import { render, staticRenderFns } from "./wrestler_division_card.vue?vue&type=template&id=1ec03145&"
import script from "./wrestler_division_card.vue?vue&type=script&lang=js&"
export * from "./wrestler_division_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports